
import {
  GET_ORDER,
  GET_ORDER_SUCCESS,
  GET_ORDER_ERROR,
  GET_ORDER_SUMMARY,
  GET_ORDER_SUMMARY_SUCCESS,
  GET_ORDER_SUMMARY_ERROR,
  GET_ORDER_SUMMARY_CONFIRMATION,
  GET_ORDER_SUMMARY_CONFIRMATION_SUCCESS,
  GET_ORDER_SUMMARY_CONFIRMATION_ERROR,
  COMPLETE_ADDITIONAL_STEPS_AFTER_PAYMENT,
  COMPLETE_ADDITIONAL_STEPS_AFTER_PAYMENT_SUCCESS,
  COMPLETE_ADDITIONAL_STEPS_AFTER_PAYMENT_ERROR,
  UPDATE_ORDER,
  UPDATE_ORDER_SUCCESS,
  UPDATE_ORDER_ERROR
} from "../actions";

export const updateOrder = (order, activityInfo) => ({
  type: UPDATE_ORDER,
  payload: { order, activityInfo },
});

export const updateOrderSuccess = (orderData) => ({
  type: UPDATE_ORDER_SUCCESS,
  payload: orderData,
});

export const updateOrderError = (message) => ({
  type: UPDATE_ORDER_ERROR,
  payload: { message },
});

export const getOrderConfirmation = (orderId, invoiceId, activityInfo) => ({
  type: GET_ORDER_SUMMARY_CONFIRMATION,
  payload: { orderId, invoiceId, activityInfo },
});

export const getOrderConfirmationSuccess = (orderConfirmation) => ({
  type: GET_ORDER_SUMMARY_CONFIRMATION_SUCCESS,
  payload: orderConfirmation,
});

export const getOrderConfirmationError = (message) => ({
  type: GET_ORDER_SUMMARY_CONFIRMATION_ERROR,
  payload: { message },
});

export const getOrder = (orderId) => ({
  type: GET_ORDER,
  payload: { orderId },
});

export const getOrderSuccess = (orderData) => ({
  type: GET_ORDER_SUCCESS,
  payload: orderData,
});

export const getOrderError = (message) => ({
  type: GET_ORDER_ERROR,
  payload: { message },
});

export const getOrderSummary = (orderId, contactId, activityInfo) => ({
  type: GET_ORDER_SUMMARY,
  payload: { orderId, contactId, activityInfo },
});

export const getOrderSummarySuccess = (orderSummary) => ({
  type: GET_ORDER_SUMMARY_SUCCESS,
  payload: orderSummary,
});

export const getOrderSummaryError = (message) => ({
  type: GET_ORDER_SUMMARY_ERROR,
  payload: { message },
});

export const completeAdditionalStepsAfterPayment = (orderId, invoiceId) => ({
  type: COMPLETE_ADDITIONAL_STEPS_AFTER_PAYMENT,
  payload: { orderId, invoiceId },
});

export const completeAdditionalStepsAfterPaymentSuccess = (completionStatusOfAdditionalSteps) => ({
  type: COMPLETE_ADDITIONAL_STEPS_AFTER_PAYMENT_SUCCESS,
  payload: completionStatusOfAdditionalSteps,
});

export const completeAdditionalStepsAfterPaymentError = (message) => ({
  type: COMPLETE_ADDITIONAL_STEPS_AFTER_PAYMENT_ERROR,
  payload: { message },
});

